import styled from 'styled-components'

export const Title = styled.p`
  margin: 0;
  color: ${props => props.color || props.theme.colors.blueGrey};
  font-family: ${props => props.theme.fonts.Montserrat};
  font-size: ${props => props.fontSize || '14'}px;
  font-weight: 500;
  padding-top: ${props => props.pt || '30px'};
  padding-left: ${props => props.pl || '30px'};
  padding-bottom: ${props => props.pb};
  @media screen and (max-width: 960px) {
    font-size: 14px;
  }
`

export const Text = styled.p`
  font-family: ${props => props.font};
  font-size: ${props => props.fontSize}px;
  color: ${props => props.color};
  font-weight: ${props => props.weight};
  margin-bottom: 0px;
  line-height: ${props => props.lh || 'inherit'};
  padding-top: ${props => props.pt || 0}px;
  padding-right: ${props => props.pr || 0}px;
  padding-bottom: ${props => props.pb || 0}px;
  padding-left: ${props => props.pl || 0}px;
  @media screen and (max-width: 960px) {
    font-size: ${props => props.fontSize || '12'}px;
  }
  @media screen and (max-width: 575.98px) {
    font-size: 14px;
  }
`
